/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssetIncomeMonthRequest } from './AssetIncomeMonthRequest';
import {
    AssetIncomeMonthRequestFromJSON,
    AssetIncomeMonthRequestFromJSONTyped,
    AssetIncomeMonthRequestToJSON,
    AssetIncomeMonthRequestToJSONTyped,
} from './AssetIncomeMonthRequest';
import type { SpecialPaymentCount } from './SpecialPaymentCount';
import {
    SpecialPaymentCountFromJSON,
    SpecialPaymentCountFromJSONTyped,
    SpecialPaymentCountToJSON,
    SpecialPaymentCountToJSONTyped,
} from './SpecialPaymentCount';

/**
 * 
 * @export
 * @interface AssetIncomeRequest
 */
export interface AssetIncomeRequest {
    /**
     * 
     * @type {string}
     * @memberof AssetIncomeRequest
     */
    id: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetIncomeRequest
     */
    payerNameAndAddress: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetIncomeRequest
     */
    incomeType: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetIncomeRequest
     */
    hasSpecialPayments: boolean | null;
    /**
     * 
     * @type {SpecialPaymentCount}
     * @memberof AssetIncomeRequest
     */
    specialPaymentCount: SpecialPaymentCount | null;
    /**
     * 
     * @type {number}
     * @memberof AssetIncomeRequest
     */
    dailyRate: number | null;
    /**
     * 
     * @type {string}
     * @memberof AssetIncomeRequest
     */
    note: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetIncomeRequest
     */
    isPartiallyGarnished: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetIncomeRequest
     */
    hasEmployerFamilyAllowance: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetIncomeRequest
     */
    hasEmployerSettledExpenses: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetIncomeRequest
     */
    hasBenefitInKind: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof AssetIncomeRequest
     */
    benefitInKindAmount: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetIncomeRequest
     */
    receivesTips: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof AssetIncomeRequest
     */
    monthlyTipAmount: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetIncomeRequest
     */
    hasExpenseAllowances: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetIncomeRequest
     */
    isAverageRepresentative: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssetIncomeRequest
     */
    nonRepresentativeReason: string | null;
    /**
     * 
     * @type {number}
     * @memberof AssetIncomeRequest
     */
    actualAverageIncome: number | null;
    /**
     * 
     * @type {Array<AssetIncomeMonthRequest>}
     * @memberof AssetIncomeRequest
     */
    months: Array<AssetIncomeMonthRequest>;
}



/**
 * Check if a given object implements the AssetIncomeRequest interface.
 */
export function instanceOfAssetIncomeRequest(value: object): value is AssetIncomeRequest {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('payerNameAndAddress' in value) || value['payerNameAndAddress'] === undefined) return false;
    if (!('incomeType' in value) || value['incomeType'] === undefined) return false;
    if (!('hasSpecialPayments' in value) || value['hasSpecialPayments'] === undefined) return false;
    if (!('specialPaymentCount' in value) || value['specialPaymentCount'] === undefined) return false;
    if (!('dailyRate' in value) || value['dailyRate'] === undefined) return false;
    if (!('note' in value) || value['note'] === undefined) return false;
    if (!('isPartiallyGarnished' in value) || value['isPartiallyGarnished'] === undefined) return false;
    if (!('hasEmployerFamilyAllowance' in value) || value['hasEmployerFamilyAllowance'] === undefined) return false;
    if (!('hasEmployerSettledExpenses' in value) || value['hasEmployerSettledExpenses'] === undefined) return false;
    if (!('hasBenefitInKind' in value) || value['hasBenefitInKind'] === undefined) return false;
    if (!('benefitInKindAmount' in value) || value['benefitInKindAmount'] === undefined) return false;
    if (!('receivesTips' in value) || value['receivesTips'] === undefined) return false;
    if (!('monthlyTipAmount' in value) || value['monthlyTipAmount'] === undefined) return false;
    if (!('hasExpenseAllowances' in value) || value['hasExpenseAllowances'] === undefined) return false;
    if (!('isAverageRepresentative' in value) || value['isAverageRepresentative'] === undefined) return false;
    if (!('nonRepresentativeReason' in value) || value['nonRepresentativeReason'] === undefined) return false;
    if (!('actualAverageIncome' in value) || value['actualAverageIncome'] === undefined) return false;
    if (!('months' in value) || value['months'] === undefined) return false;
    return true;
}

export function AssetIncomeRequestFromJSON(json: any): AssetIncomeRequest {
    return AssetIncomeRequestFromJSONTyped(json, false);
}

export function AssetIncomeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetIncomeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'payerNameAndAddress': json['payerNameAndAddress'],
        'incomeType': json['incomeType'],
        'hasSpecialPayments': json['hasSpecialPayments'],
        'specialPaymentCount': SpecialPaymentCountFromJSON(json['specialPaymentCount']),
        'dailyRate': json['dailyRate'],
        'note': json['note'],
        'isPartiallyGarnished': json['isPartiallyGarnished'],
        'hasEmployerFamilyAllowance': json['hasEmployerFamilyAllowance'],
        'hasEmployerSettledExpenses': json['hasEmployerSettledExpenses'],
        'hasBenefitInKind': json['hasBenefitInKind'],
        'benefitInKindAmount': json['benefitInKindAmount'],
        'receivesTips': json['receivesTips'],
        'monthlyTipAmount': json['monthlyTipAmount'],
        'hasExpenseAllowances': json['hasExpenseAllowances'],
        'isAverageRepresentative': json['isAverageRepresentative'],
        'nonRepresentativeReason': json['nonRepresentativeReason'],
        'actualAverageIncome': json['actualAverageIncome'],
        'months': ((json['months'] as Array<any>).map(AssetIncomeMonthRequestFromJSON)),
    };
}

export function AssetIncomeRequestToJSON(json: any): AssetIncomeRequest {
    return AssetIncomeRequestToJSONTyped(json, false);
}

export function AssetIncomeRequestToJSONTyped(value?: AssetIncomeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'payerNameAndAddress': value['payerNameAndAddress'],
        'incomeType': value['incomeType'],
        'hasSpecialPayments': value['hasSpecialPayments'],
        'specialPaymentCount': SpecialPaymentCountToJSON(value['specialPaymentCount']),
        'dailyRate': value['dailyRate'],
        'note': value['note'],
        'isPartiallyGarnished': value['isPartiallyGarnished'],
        'hasEmployerFamilyAllowance': value['hasEmployerFamilyAllowance'],
        'hasEmployerSettledExpenses': value['hasEmployerSettledExpenses'],
        'hasBenefitInKind': value['hasBenefitInKind'],
        'benefitInKindAmount': value['benefitInKindAmount'],
        'receivesTips': value['receivesTips'],
        'monthlyTipAmount': value['monthlyTipAmount'],
        'hasExpenseAllowances': value['hasExpenseAllowances'],
        'isAverageRepresentative': value['isAverageRepresentative'],
        'nonRepresentativeReason': value['nonRepresentativeReason'],
        'actualAverageIncome': value['actualAverageIncome'],
        'months': ((value['months'] as Array<any>).map(AssetIncomeMonthRequestToJSON)),
    };
}

